import { getData } from '../../_helpers/getData';
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "../Navbar";
import TopBar from "../topbar";
import Footer from "../../layout/footer";
import constant from "../../_config/constant";
import moment from "moment";
import Pagination from "react-js-pagination";
import Tippy from "@tippy.js/react";
import { propertyService } from "../../_services";
import { BiDotsHorizontalRounded } from "react-icons/bi";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getInitials } from "../../_helpers/helpers";

export default function ReviewList(props) {
  const [requesting, setRequesting] = useState(true);
  const [list, setList] = useState([]);
  const [refreshKey, setRefreshKey] = useState(0);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);

  var limit = 10;

  const decoded = getData();

  const pageChange = (page) => {
    setPage(page);
    setRequesting(true);
    setRefreshKey((oldKey) => oldKey + 1);
  };

  useEffect(() => {
    setRequesting(true);

    propertyService.reviewsList({ page, limit: 10 }).then(
      (objS) => {
        console.clear();

        setList(objS.data.docs);
        setTotal(objS.data.total);
        setRequesting(false);
        // window.scrollTo({ top: 0, behavior: "smooth" });
      },
      (error) => {
        setRequesting(false);
      }
    );
  }, [refreshKey]);

  return (
    <div id="main-wrapper">
      <ToastContainer />
      <TopBar user={decoded} showSearch={false} title="Review List" />

      <div className="deznav">
        <div className="deznav-scroll">
          <Navbar />
        </div>
      </div>

      <div className="content-body">
        <div className="container-fluid">
          <div className="row">
            <div className="col-xl-12">
              <div className="tab-content">
                <div className="tab-pane active show" id="All">
                  <div className="table-responsive">
                    {requesting && (
                      <div className="tw-my-10 tw-flex tw-items-center tw-justify-center">
                        <div className="bg-white tw-w-max rounded shadow-md p-4">
                          <div className="loader"></div>
                        </div>
                      </div>
                    )}
                    <table
                      className="table card-table  display mb-4 dataTablesCard booking-table room-list-tbl table-responsive-lg "
                      id="guestTable-all"
                    >
                      <thead>
                        <tr>
                          <th>Review Id</th>
                          <th>Listing Name</th>
                          <th>User Name</th>
                          <th>Message</th>
                          <th>Rating</th>
                          <th>Created At</th>
                          <th>Updated At</th>
                        </tr>
                      </thead>
                      <tbody>
                        {list.map((curr, id) => (
                          <tr key={id}>
                            <td>{curr.id}</td>
                            <td>{curr.propertyId.listingName}</td>
                            <td>{curr.userId.name ? getInitials(curr.userId.name) : curr.userId.name}</td>
                            <td>{curr.message}</td>
                            <td>{curr.rating}</td>
                            <td>
                              {moment(curr.createdAt).format("MMMM Do, YYYY")}
                            </td>
                            <td>
                              {moment(curr.updatedAt).format("MMMM Do, YYYY")}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Pagination
            activePage={page}
            itemsCountPerPage={limit}
            totalItemsCount={total}
            pageRangeDisplayed={10}
            onChange={pageChange}
          />
        </div>
      </div>

      <Footer />
    </div>
  );
}
